<template>
  <div>

    <v-app-bar :flat="!scrolled" app class="blur-menu  menu-style px-4">

      <div class="pt-2">
        <img v-if="scrolled || userStore.isAuthenticated" :src="logoSrc" @click="router.push('/')"
          alt="Hokejovy manazer Logo" :width="$vuetify.display.mdAndUp ? '100' : '160'" class="cursor-pointer" />
        <div v-else style="min-width:100px">

        </div>
      </div>




      <v-spacer></v-spacer>

      <!-- Menu pro desktop -->


      <v-btn @click="router.push('/leagues')" variant="text" color="black"
        class="d-none  d-md-flex">Organizace</v-btn><span class="text-black d-none d-md-flex">|</span>
      <v-btn @click="router.push('/teams')" variant="text" color="black" class="d-none d-md-flex">Týmy</v-btn><span
        class="text-black d-none d-md-flex">|</span>
      <v-btn @click="router.push('/articles')" variant="text" color="black" class="d-none d-md-flex">Články</v-btn><span
        class="text-black d-none d-md-flex">|</span>
      <v-btn @click="router.push('/contact')" variant="text" color="black" class="d-none d-md-flex">Kontakt</v-btn>
      <!-- Tlačítko pro zobrazení login overlay, pokud uživatel není přihlášen -->
      <!--
      <v-spacer v-if="!userStore.isAuthenticated"></v-spacer>
      
      
      <v-btn @click="appStore.showLoginOverlay()" v-if="!userStore.isAuthenticated" variant="icon" rounded color="black"
        class="d-none d-md-flex"><v-icon>mdi-login</v-icon></v-btn>
      -->
      <v-spacer></v-spacer>
      <!-- Zobrazit avatar s rozbalovací nabídkou, pokud je uživatel přihlášen -->


      <!-- Avatar ALWAYS toggles right drawer (desktop + mobile). If not logged in, show generic avatar. -->
      <div style="min-width:120px; text-align: right;">
        <v-btn icon rounded color="black" @click="toggleDrawer">
          <v-avatar class="cursor-pointer" color="primary" size="36">
            <template v-if="userStore.isAuthenticated">
              <span>{{ userInitials }}</span>
            </template>
            <template v-else>
              <v-icon>mdi-account-circle</v-icon>
            </template>
          </v-avatar>
        </v-btn>
      </div>






      <!-- Ikonka menu pro mobilní zařízení -->



    </v-app-bar>


    <!-- Boční menu pro mobilní zařízení -->
    <v-navigation-drawer v-model="drawer" app temporary color="" location="end">
      <v-list>

        <v-list-item v-if="userStore.isAuthenticated" @click="openMyProfile">
          <v-list-item-title><v-icon>mdi-badge-account-outline</v-icon> Můj profil</v-list-item-title>
        </v-list-item>
        <v-list-item v-if="userStore.isAuthenticated" @click="router.push('/users/userList')">
          <v-list-item-title><v-icon>mdi-account-group</v-icon> Moji hráči</v-list-item-title>
        </v-list-item>

        <v-list-item @click="router.push('/register-dependent')">
          <v-list-item-title><v-icon>mdi-human-male-child</v-icon> Vytvořit závislý účet</v-list-item-title>
        </v-list-item>

        <v-list-item v-if="userStore.isAuthenticated" @click="logout">
          <v-list-item-title><v-icon>mdi-logout</v-icon> Odhlásit</v-list-item-title>
        </v-list-item>
        <v-list-item v-else @click="goToLogin()">
          <v-list-item-title><v-icon>mdi-login</v-icon> Login</v-list-item-title>
        </v-list-item>
        <v-divider></v-divider>

        <v-list-item @click="router.push('/')">
          <v-list-item-title>Domů</v-list-item-title>
        </v-list-item>

        <v-list-item v-for="item in menuTitles" :key="item._id" @click="navigateToArticle(item.urlTitle)">
          <v-list-item-title>{{ item.menuTitle }}</v-list-item-title>
        </v-list-item>
        <v-list-item @click="router.push('/leagues')">
          <v-list-item-title>Organizace</v-list-item-title>
        </v-list-item>
        <v-list-item @click="router.push('/teams')">
          <v-list-item-title>Týmy</v-list-item-title>
        </v-list-item>
        <v-list-item @click="router.push('/articles')">
          <v-list-item-title>Články</v-list-item-title>
        </v-list-item>
        <v-list-item @click="router.push('/contact')">
          <v-list-item-title>Kontakt</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, onUnmounted } from 'vue';
import { useUserStore } from '@/stores/user/userStore'; // Import user store
import { useAppStore } from '@/stores/app/appStore'; // Import app store
import { useRouter } from 'vue-router';
import { useRoute } from 'vue-router';
import axiosInstance from '@/services/axiosInstance';
import LogoPath from '@/assets/img/logos/hockeybook-path.svg';
import LogoAngle from '@/assets/img/logos/logo-angle.svg';
import { useDisplay } from 'vuetify';


const { mdAndUp } = useDisplay();

// desktop (md+) => hockeybook-path, mobile => logo-angle
const logoSrc = computed(() => (mdAndUp.value ? LogoAngle : LogoPath));

const scrolled = ref(false);

const route = useRoute();

const handleScroll = () => {
  scrolled.value = window.scrollY > 130;
};

onMounted(() => {
  window.addEventListener('scroll', handleScroll);
});
onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll);
});

// Přístup k routeru
const router = useRouter();

// Stav pro boční menu (drawer)
const drawer = ref(false);

const menuTitles = ref<{ _id: string; menuTitle: string; urlTitle: string }[]>([]);
// Přístup do user store
const userStore = useUserStore();
const appStore = useAppStore();

// Kontrola, zda přihlášený uživatel má roli coach nebo administrator
const canSeeUsers = computed(() => {
  const roles = userStore.user?.userRoles || []
  return roles.includes('administrator')
})



// ⬇️ NOVÉ: přesměrování na "/" s návratovým parametrem
const goToLogin = () => {
  drawer.value = false; // Zavře drawer před přesměrováním
  // zachová celou aktuální cestu včetně query/hash
  const returnTo = route.fullPath || `/events/${route.params.id}`;
  router.push({ path: '/', query: { returnTo } });
};


const toggleDrawer = () => {
  drawer.value = !drawer.value
}


const openMyProfile = () => {
  // console.log('Otevřít můj profil');

  // Zajištění, že `userStore.user` existuje a obsahuje požadované hodnoty
  if (!userStore.user || !userStore.user._id || !userStore.user.searchName) {
    console.error('Uživatelská data nejsou kompletní');
    return;
  }

  const searchNameArr = userStore.user.searchName.split(' ');

  // Zajištění, že `userStore.user` existuje a obsahuje požadované hodnoty
  if (searchNameArr.length < 2) {
    console.error('searchNameArr data nejsou kompletní');
    return;
  }
  // console.log('searchNameArr:', searchNameArr);

  const myProfileRoute = `/users/${userStore.user._id}-${searchNameArr[0]}-${searchNameArr[1]}`;

  // console.log('Otevřít můj profil:', myProfileRoute);

  // Odeslání uživatele na stránku profilu
  router.push(myProfileRoute);
};

const navigateToArticle = (urlTitle: string) => {
  router.push(`/articles/${urlTitle}`);
};

const openFacebookProfile = () => {
  // console.log('Otevřít Facebook profil');
  window.open('https://www.facebook.com/www.modernhockey.eu', '_blank');
};

const openInstagramProfile = () => {
  // console.log('Otevřít Facebook profil');
  window.open('https://www.instagram.com/modernhockey.eu/', '_blank');
};

const openYoutubeProfile = () => {
  // console.log('Otevřít Facebook profil');
  window.open('https://www.youtube.com/@Modernhockeyeu', '_blank');
};


// Výpočet iniciál uživatele
const userInitials = computed(() => {
  if (!userStore.user) return '';
  const names = userStore.user.name.split(' ');
  return names.map(n => n[0]).join('').toUpperCase();
});

// Funkce pro odhlášení
const logout = () => {
  userStore.clearUser(); // Vymazat uživatelská data ze store a odhlásit uživatele
  router.push('/')
};



onMounted(async () => {
  try {
    const response = await axiosInstance.get(`/articles/menutitles`);
    menuTitles.value = response.data; // Načtení položek do `menuTitles`
  } catch (error) {
    console.error('Chyba při načítání menu položek:', error);
  }
});



</script>

<style scoped>
.fb-icon {
  border-radius: 25px;
}


.menu-style {
  position: relative;
  top: 0;
  left: 0px;
  z-index: 1000;
}

.user-menu {
  -webkit-backdrop-filter: blur(4px);
  /* Pro Safari */

  backdrop-filter: blur(4px);
}

.v-avatar {
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  color: white;
}

/* Nastavení maximální šířky pro mobilní zařízení */
@media (max-width: 600px) {
  .v-menu__content {
    max-width: 150px !important;
    /* Menu bude užší na menších zařízeních */
  }
}

/* Nastavení větší šířky pro větší zařízení */
@media (min-width: 600px) {
  .v-menu__content {
    max-width: 200px !important;
    /* Menu bude širší na větších zařízeních */
  }
}
</style>